import { $host } from '../index';

//  Глобальный поиск по сайту - включая категории и кейсы в категориях.
export const globalSearch = async (term) => {
    try
    {
        const token = localStorage.getItem('token');

        const { data } = await $host.post('api/search/do', { token, term });

        if (data?.error)
            throw new Error(data.error);

        return data;
    }catch (error)
    {
        console.error(error);

        return {
            error: error.message
        };
    }
};